import { useSelector } from 'react-redux';

import { Fleet } from '../interfaces';
import { selectFleet } from '../selectors';

export const useFleet = (): Fleet => {
  const fleet = useSelector(selectFleet);
  return fleet;
};
